import Button from './Button';

type Props = {
    text: string;
    onClick: () => void;
};

export default function ContinueButton({ text, onClick }: Props) {
    return (
        <div className="continue-button-wrapper">
            <Button onClick={onClick} className="secondary-button">
                {text}
            </Button>
        </div>
    );
}
